import {
  injectAdTag,
  injectBrand
} from "@fresh8/ad-data-composition/src/brand";
import { AdTemplateHeaderCtaButton } from "@fresh8/types/src";
import { computed } from "vue";

export function getCtaButton(): AdTemplateHeaderCtaButton {
  const adTag = injectAdTag();
  const brand = injectBrand();
  const ctaButton = computed(() => {
    let cta = {
      text: "Bet Now",
      url: "",
      id: ""
    };
    if (brand?.adTemplate.value?.header.ctaButton) {
      cta = { ...brand.adTemplate.value.header.ctaButton };
    }

    const campaignTarget = adTag?.selectedCampaign.value?.targetUrl;
    const fallbackUrl =
      adTag?.adTag.value?.tracking[adTag.selectedOperator?.value?._id || ""]
        ?.fallbackUrl;
    if (campaignTarget && campaignTarget !== "") {
      cta.url = campaignTarget;
    } else if (fallbackUrl && fallbackUrl !== "") {
      cta.url = fallbackUrl;
    }

    return cta;
  });
  return ctaButton.value;
}
